import React, { useState, useEffect } from 'react'
import { ConfigContext } from './context'
import { isFalsyOrEmpty } from '../../components/helpers/object'
import axios from 'axios'
import dayjs from 'dayjs';
import { ServiceInfo } from '../../services/dto/serviceinfo.dto';
import {version} from '../../../package.json'

export const ConfigProvider = ({children}) => {
  const [config, setConfig] = useState();
  const [loadedpalette, setLoadedPalette] = useState(false);
  const [palette, setPalette] = useState();

  useEffect(() => {
    ReloadConfiguration();
  }, [])

  const ReloadConfiguration = async () => {
    GetConfiguration();
    GetResources();
    GetPalette();
    GetVersion();
  }

  async function GetConfiguration() {
    await axios({
      method: 'get',
      url: './config.json',
      responseType: 'json'
    })
    .then(res => { 
      axios({
        method: 'get', 
        url: res.data.configurl + "config.json?apa=" + Date.now(),
        headers : { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
         },
        responseType: 'json'
      })
      .then(rez => { 
        if (!isFalsyOrEmpty(config))
        {
          if (JSON.stringify(config) !== rez.data)
            setConfig(rez.data);
        }
        setConfig(rez.data);
      })
      .catch(err => console.log(err))
    })
  }

const GetPalette = async () => {
  return await axios({
    method: 'get',
    url: './theme.json',
    responseType: 'json'
  })
  .then(res => { setPalette(res.data); setLoadedPalette(true);})
}

const GetResources = async () => {
    await axios({
      method: 'get',
      url: './config.json',
      responseType: 'json'
    })
    .then(rez => {
        axios({
          method: 'get', 
          url: rez.data.configurl + "offices.json?apa=" + Date.now(),
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
            },
          responseType: 'json'
        }).then(rex => {
          if (!isFalsyOrEmpty(rex))
            sessionStorage.setItem("resources", JSON.stringify(rex.data));
        })
    })
    .catch(error => console.log(error))
}

const GetVersion = () => {
  var stored = localStorage.getItem("version");
  var newversion = version;
  if (isFalsyOrEmpty(stored) || stored === "undefined")
  {
    localStorage.setItem("version", newversion);
    localStorage.removeItem("language");
    window.location.reload();
  }
  else
  {
    if (stored < newversion)
    {
      console.log("OLD VERSION FOUND")
      localStorage.removeItem("version");
      localStorage.removeItem("language");
      window.location.reload();
    }
    console.log("CURRENT VERSION FOUND")
  }
}

// Vad ska den här klassen/interfejset göra?
// Vi ska kunna kolla vilka köer som ska vara öppna för vilka kontor, under vilka dagar och timmar.
// Sedan ska vi filtrera bort de resultat som inte faller innom ramarna

const Queuefilter = async (officeID, queues) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources) && officeID && queues)
  {
    const offices = tmpresources["offices"].find(x => x.id === officeID);
    if (offices)
    {
      const qs = offices["queues"];
      const queuetemplates = offices["queuetemplates"];
      var templateresults = queuetemplates.map(x => GetTemplate("queue", x));
      var queueresource = templateresults.concat(qs);
      if (queueresource)
      {
        
        //Fixa logiken: just nu filtrerar vi inte ordentligt
        const firstfilter = queues.filter(x => 
                              queueresource.find(
                              (y => (y.id === x.queueID)
                              && y.showQueue === true
                              && IsOpen(y)
                              )));
        return firstfilter;
      }
    }
  }
  else return null;
}

// Takes a queue resource object or a checkin resource object as parameter
const IsOpen = (queue) => {
  const day = dayjs().format('ddd').toLowerCase();
  const hour = dayjs().format('H');
  const minute = dayjs().format('m');

  var result = queue.openhourtemplates.map(a => GetTemplate("openhour", a)).flat().concat(queue.openhours).filter(x => !isFalsyOrEmpty(x)).some(z => z.days.some(a => a === day) 
    && dayjs().hour(z.open_hour).minute(z.open_minute).isBefore(dayjs().hour(hour).minute(minute)) 
    && dayjs().hour(z.close_hour).minute(z.close_minute).isAfter(dayjs().hour(hour).minute(minute)))
  return result;
}

//På samma sätt kan vi vilja filtrera bort kontor som kunden har men inte vill visa!
const OfficeFilter = async (officelist) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources))
  {
    const offices = tmpresources["offices"];
    if (isFalsyOrEmpty(officelist))
      return offices;
    var filteredOffices = officelist.filter(x => offices.find(y => y.id === x.officeID && y.showOffice === true));
    return filteredOffices;
  }
  console.error("could not get resource file");
  return officelist;
}

const IsOfficeActive = (officeID) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources))
  {
    const offices = tmpresources["offices"];
    var result = offices.some(x => x.id === officeID && x.showOffice === true);
    return result;
  }
  return true;
}

const UpdateQueueDataFromConfig = (officeID, queuedata) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  var updatedqueues = null;
  try {
    const office = tmpresources["offices"].find(x => x.id === officeID);
    if (isFalsyOrEmpty(office))
      return null;
    const qtemplates = office["queuetemplates"];
    const qs = qtemplates.map(x => GetTemplate("queue", x));
    const queues = qs.concat(office["queues"]).filter(x => queuedata.find(y => y.queueID === x.id));
    updatedqueues = queues.map(x => { 
      var q = queuedata.find(y => y.queueID === x.id);
      return new ServiceInfo(x.name, q.peopleWaiting, q.actualWaitTime, q.active, q.queueID, x.gala_segment, x.gala_service);
    });
  }
  catch{

  }
  return updatedqueues;
}

const GetOfficeIDFromUrlID = urlid => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources))
  {
    const result = tmpresources["offices"].find(x => x.urlid.toString() === urlid);
    if (result)
      return result.id;
  }
  else
    return null;
}

const GetUrlIDFromOfficeID = officeid => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources))
  {
    const result = tmpresources["offices"].find(x => x.id === officeid);
    if (result)
      return result.urlid;
  }
  else
    return null;
}

const GetQueueIDfromUrlID = (oid, qid) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources))
  {
    var office = tmpresources["offices"].find(x => x.id === oid);
    const templatenames = office["queuetemplates"];
    var templateresults = templatenames.map(x => GetTemplate("queue", x));
    var queues = office["queues"];
    const result = templateresults.concat(queues).find(x => x.urlid.toString() === qid);
    if (result)
      return result.id;
  }
  else
    return null;
}

const GetUrlIDFromQueueID = (oid, qid) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources))
  {
    var office = tmpresources["offices"].find(x => x.id === oid);
    const templatenames = office["queuetemplates"];
    var templateresults = templatenames.map(x => GetTemplate("queue", x));
    const result = templateresults.concat(office["queues"]).find(x => x.id === qid);
    if (result)
      return result.urlid;
  }
  else
    return null;
}

const GetQueuenameFromQueueID = (oid, qid) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources))
  {
    var office = tmpresources["offices"].find(x => x.id === oid);
    const templatenames = office["queuetemplates"];
    var templateresults = templatenames.map(x => GetTemplate("queue", x));
    const result = templateresults.concat(office["queues"]).find(x => x.id === qid);
    if (result)
      return result.name;
  }
  else
    return null;
}

const GetPrinterData = async officeID => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources) && officeID)
  {
    const offices = tmpresources["offices"].find(x => x.id === officeID);
    if (offices)
    {
      const printerNumber = offices["NQCPrinterNumber"];
      const printerTextNumber = offices["NQCPrinterTextNumber"];
      if (printerNumber && printerTextNumber)
        return { printerNumber, printerTextNumber };
      else
        return null;
    }
  }
}

const GetCheckinData = officeID => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources) && officeID)
  {
    const office = tmpresources["offices"].find(x => x.id === officeID);
    if (office)
    {
      try
      {
        if (!isFalsyOrEmpty(office.checkin))
          return office.checkin
        else
          return null;
      }
      catch (error)
      {
        console.log(error);
        return null;
      }
    }
  }
}

const ShouldShowTicketInfo = (param, queueid) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  const officeID = localStorage.getItem("selectedoffice");
  const queueID = queueid || localStorage.getItem("selectedqueue");
  if (!isFalsyOrEmpty(tmpresources) && officeID && queueID)
  {
    const office = tmpresources["offices"].find(x => x.id === officeID);
    if (office)
    {
      const officeqtemplates = office["queuetemplates"];
      if (!isFalsyOrEmpty(officeqtemplates))
      {
        const qtemplates = tmpresources["templates"]["queuetemplates"].filter(x => officeqtemplates.includes(x.name));
        const qtemplate = qtemplates.find(x => x.value.id === queueID);
        if (!isFalsyOrEmpty(qtemplate))
        {
          if (param === "ticketnumber")
            return qtemplate.value.showTicketNumber;
          if (param === "peopleahead")
            return qtemplate.value.showPeopleAhead;
          if (param === "showdirection")
            return qtemplate.value.showDirectionInTicket;
          if (param === "formsdata")
            return qtemplate.value.showFormsDataInTicket;
          else
            return false;
        }
      }
      else
      {
        const ques = office["queues"];
        const q = ques.find(x => x.id === queueID);
        if (!isFalsyOrEmpty(q))
        {
          if (param === "ticketnumber")
            return q.showTicketNumber;
          if (param === "peopleahead")
            return q.showPeopleAhead;
          if (param === "showdirection")
            return q.showDirectionInTicket;
          if (param === "formsdata")
            return q.showFormsDataInTicket;
          else
            return false;
        }
      }
    }
  }  
  return true;
}

const CheckIfHasForm = ( officeID, serviceinfo ) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources) && officeID && serviceinfo)
  {
    const office = tmpresources["offices"].find(x => x.id === officeID);
    if (office)
    {
      const templatenames = office["queuetemplates"];
      var templateresults = templatenames.map(x => GetTemplate("queue", x));
      var servicetype = templateresults.concat(office["queues"]).find(x => x.id === serviceinfo.queueID || (x.gala_segment === serviceinfo.segmentID && x.gala_service === serviceinfo.serviceID));
      if (servicetype && servicetype.hasforms === true)
        return true;
    }
  }
  return false;
}

//TODO: Undersök om den är stabil med min regel att queuetemplates bara får ha formtemplates, inte egna forms
const GetFormData = ( officeID, serviceinfo ) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources) && officeID && serviceinfo)
  {
    const office = tmpresources["offices"].find(x => x.id === officeID.toString());
    if (office)
    {
      const templatenames = office["queuetemplates"];
      var templateresults = templatenames.map(x => GetTemplate("queue", x));
      var servicetype = templateresults.concat(office["queues"]).find(x => x.id === serviceinfo.queueID || (x.gala_segment === serviceinfo.segmentID && x.gala_service === serviceinfo.serviceID));
      if (servicetype && servicetype.hasforms === true)
      {
        var templates = GetTemplate("form", servicetype.formtemplate);
        return templates.concat(servicetype.forms).flat();
      }
    }
  }
  return null;
}

const GetFormName = ( officeID, serviceinfo ) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources) && officeID && serviceinfo)
  {
    const office = tmpresources["offices"].find(x => x.id === officeID.toString());
    if (office)
    {
      const templatenames = office["queuetemplates"];
      var templateresults = templatenames.map(x => GetTemplate("queue", x));
      var servicetype = templateresults.concat(office["queues"]).find(x => x.id === serviceinfo.queueID || (x.gala_segment === serviceinfo.segmentID && x.gala_service === serviceinfo.serviceID));
      if (servicetype && servicetype.hasforms === true)
      {
        return servicetype.formtemplate;
      }
    }
  }
  return null;
}

const GetTemplate = (type, name) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  let templates = tmpresources["templates"];
  let selectedtemplate;
  var item = null;
  if (type === "queue")
  {
    selectedtemplate = templates["queuetemplates"];
    if (selectedtemplate.length > 0)
      item = selectedtemplate.filter(x => x.name === name)
  }
  else if (type === "form")
  {
    selectedtemplate = templates["formtemplates"];
    if (selectedtemplate.length > 0)
      item = selectedtemplate.filter(x => x.name === name)
  }
  else if (type === "openhour")
  {
    selectedtemplate = templates["openhourtemplates"];
    if (selectedtemplate.length > 0)
      item = selectedtemplate.filter(x => x.name === name)
  }
  if (isFalsyOrEmpty(item))
  {
    return null;
  }  
  else
  {
    return item[0].value;
  }
}


  const value = {
    state: { config, loadedpalette, palette },
    actions: { Queuefilter, GetPalette, GetOfficeIDFromUrlID, GetResources, ReloadConfiguration, GetPrinterData, CheckIfHasForm, GetFormData, GetFormName, GetUrlIDFromOfficeID, UpdateQueueDataFromConfig, GetQueueIDfromUrlID, GetUrlIDFromQueueID, GetQueuenameFromQueueID, OfficeFilter, IsOfficeActive, ShouldShowTicketInfo, GetCheckinData, IsOpen}
  }

  return (
    <ConfigContext.Provider value = {value}>
      { children }
    </ConfigContext.Provider>
  )
}